import { updateRelationshipReferences as _updateRelationshipReferences } from '@griply/services';
import { MinimalRelationship } from '@griply/types';
import {
  collection,
  doc,
  serverTimestamp,
  updateDoc,
  writeBatch,
} from 'firebase/firestore';
import {
  FirestoreWriteOp,
  logFirestoreWriteError,
} from 'shared/services/error-tracking';

import { getDatabase } from './helpers';

export const updateRelationshipReferences = async (
  relationships: MinimalRelationship[],
) =>
  _updateRelationshipReferences({
    relationships,
    collection,
    doc,
    updateDoc,
    db: getDatabase(),
    serverTimestamp,
    writeBatch,
    onWriteError: (error) =>
      logFirestoreWriteError({
        op: FirestoreWriteOp.UpdateRelationshipReferences,
        error,
      }),
  });
